// extracted by mini-css-extract-plugin
module.exports = {"contactTablePadding":"PolicyCommonContacts_contactTablePadding__3ly1B","wrapColumnWidth":"PolicyCommonContacts_wrapColumnWidth__OzpZz"};